import { render, staticRenderFns } from "./koruCustomer.vue?vue&type=template&id=2face43e&"
import script from "./koruCustomer.vue?vue&type=script&lang=js&"
export * from "./koruCustomer.vue?vue&type=script&lang=js&"
import style0 from "./koruCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports